import { CategoryModelType } from '@teinor/erp/types/company/category'
import { CategoryLangModelType } from '@teinor/erp/types/company/category/categoryLang'
import { useParams } from 'react-router'
import { ModalCreateEditMediumLoading, MediumModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { useBasicData } from '../../../../../../../utils/hooks/useBasicData'
import useLangData from '../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs } from '../../../../../../../utils/reducers/getters'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import { ProductTypesPayload } from '../../../../../../../utils/reducers/products/productTypes'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { addDictionaryExtraLine } from '../../../../../../../utils/globals/dictionary'
import { useMemo } from 'react'
import useWasteWeightProduct from '../../../../../../../utils/hooks/product/useWasteWeightProduct'

type ModalCEMaterialCategoryProps = ModalEditComponentProps & ReduxModalCEMaterialCategory &{ }


type ModifiedCategoryLangModelType = CategoryLangModelType & CategoryModelType & {
    categoryLangs: string
}
const ModalCEMaterialCategory: React.FC<ModalCEMaterialCategoryProps> = ({ userPermissions, allRowData, productTypes, ...rest }) => {
    const { CategoryId } = useParams()
    const { basicData } = useBasicData({ url: '/api/app/product/category/getCategoryInstance', params: { id: allRowData?.id }, doPetition: allRowData !== undefined})
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: basicData?.CategoryLangs, fieldsToLang: ['name'], keyValue: 'LangId' })
    const { t } = useTwinTranslation()
    const dictProductTypes = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(productTypes || {}))), [productTypes])
    const { dictWasteWeightType } = useWasteWeightProduct({})

    const fields: FormRender<ModifiedCategoryLangModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name']?.[selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'ref_code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'ProductTypeId',
                    label: t('typeProduct', 'Tipo de producto'),
                    component: 'CustomSelectWithSearchBar',
                    items: dictProductTypes,
                    sortItems: true
                },
                {
                    label: t('wasteWeightType', 'Tipo de merma'),
                    name: 'wasteWeightType',
                    component: 'CustomSelectWithSearchBar',
                    items: dictWasteWeightType,
                    value: '0'
                },
                {
                    label: t('wasteWeight', 'Merma'),
                    name: 'wasteWeight',
                    component: 'InputNumberWithLabelMargin',
                    value: ''
                },
                {
                    name: 'categoryMaterialType',
                    component: 'InputHidden',
                    value: 1
                },
                {
                    name: 'categoryLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
                {
                    name: 'CategoryId',
                    component: 'InputHidden',
                    value: CategoryId
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: allRowData?.id
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <ModalCreateEditMediumLoading fields={parsedFields} url={'/api/app/product/category/updateCategory'} translations={{ title: t('editCategory', 'Editar Categoría'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} loading={data ? false : true} />
        )
    }

    return (<MediumModalCreateEdit fields={fields} url={'/api/app/product/category/createCategory'} translations={{
        title: t('createCategory', 'Crear Categoría'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}
const modalCEMaterialCategoryDispatch = {
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}

export type ReduxModalCEMaterialCategory = ConnectedProps<typeof modalCEMaterialCategoryConnect>
const mapModalCEMaterialCategoryConnector = (state: AllReduxPayloads) => ({ productTypes: state.productTypes })
const modalCEMaterialCategoryConnect = connect(mapModalCEMaterialCategoryConnector, modalCEMaterialCategoryDispatch)
const modalCEMaterialCategoryConnectLoading = withLoading(ModalCEMaterialCategory, [{ fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' }])
const ModalCEMaterialCategoryConnect = modalCEMaterialCategoryConnect(modalCEMaterialCategoryConnectLoading)
export default ModalCEMaterialCategoryConnect